import { AppSettings } from "../types";
import { ChildData } from "../types/rcds.types";

const appSettings: AppSettings = {
  appVersion: window?.wvusSakEngagementAppSettings?.version || "",
  eletterConfig: {
    baseUrl: window?.wvusSakEngagementAppSettings?.eletterConfig?.baseURL || "",
    endpoint: window?.wvusSakEngagementAppSettings?.eletterConfig?.endpoint || "",
    apiKey: window?.wvusSakEngagementAppSettings?.eletterConfig?.apiKey || ""
  },
  logglyCustomerKey: window?.wvusSakEngagementAppSettings?.loggly_customer_key || "",
  photoModConfig: {
    baseUrl: window?.wvusSakEngagementAppSettings?.photoModConfig?.baseURL || "",
    apiKey: window?.wvusSakEngagementAppSettings?.photoModConfig?.apiKey || ""
  },
  rcdsConfig: {
    baseURL: window?.wvusSakEngagementAppSettings?.rcdsConfig?.baseURL || "",
    childDetailByIdEndpoint:
      window?.wvusSakEngagementAppSettings?.rcdsConfig?.childDetailByIdEndpoint || "",
    apiKey: window?.wvusSakEngagementAppSettings?.rcdsConfig?.apiKey || ""
  },
  sponsoredChildData: null
};

/**
 * Updates the sponsored child data in the app settings
 * @param childData The child data to set
 */
export const updateSponsoredChildData = (childData: ChildData | null) => {
  appSettings.sponsoredChildData = childData;
};

export default appSettings;
